export default __webpack_public_path__ + "static/media/logo.c343c3b7.png";